function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("circle", {
  id: "globe_svg__a",
  cx: 16,
  cy: 16,
  r: 16
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "none",
  d: "M0 0h32v32H0z"
}), React.createElement("mask", {
  id: "globe_svg__b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#globe_svg__a"
})), React.createElement("use", {
  fill: "#828EA1",
  fillRule: "nonzero",
  xlinkHref: "#globe_svg__a"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M15.527 23.349a7.475 7.475 0 00.946 0c1.124-1.331 1.844-3.77 1.964-6.53h-4.874c.12 2.76.84 5.199 1.964 6.53zm-2.248-.505c-.798-1.624-1.264-3.741-1.354-6.026H8.681a7.37 7.37 0 004.598 6.026zm2.248-14.193c-1.124 1.331-1.844 3.77-1.964 6.53h4.874c-.12-2.76-.84-5.199-1.964-6.53a7.475 7.475 0 00-.946 0zm-2.248.505a7.37 7.37 0 00-4.598 6.026h3.244c.09-2.285.556-4.402 1.354-6.026zm5.442 13.688a7.37 7.37 0 004.598-6.026h-3.244c-.09 2.285-.556 4.402-1.354 6.026zm0-13.688c.798 1.624 1.264 3.741 1.354 6.026h3.244a7.37 7.37 0 00-4.598-6.026zM16 25a9 9 0 110-18 9 9 0 010 18z",
  mask: "url(#globe_svg__b)"
}));

var SvgGlobe = function SvgGlobe(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/globe.66c9bd80.svg";
export { SvgGlobe as ReactComponent };